import * as formatTime from './formatTime.js'
import formatISO from 'date-fns/formatISO'
import endOfMonth from 'date-fns/endOfMonth'

async function executeQuery(variables) {
  return fetch(process.env.REACT_APP_API, {
    method: 'POST',
    body: JSON.stringify({
      query: QUERY,
      variables,
    }),
    options: {
      headers: {
        'x-hasura-role': 'public',
      },
    },
  }).then(res => res.json())
}

function getFirstAndLastDay(date) {
  let firstDay = new Date(date.getFullYear(), date.getMonth(), 1)

  return {
    from: formatISO(firstDay, { representation: 'date' }),
    until: formatISO(endOfMonth(firstDay), { representation: 'date' }),
  }
}

export let getTimeSlot = async (locationId, medicalPlan, date) => {
  let { from, until } = getFirstAndLastDay(date)

  let res = await executeQuery({
    from,
    until,
    location_id: parseInt(locationId, 10),
    medical_plan: medicalPlan,
  })

  let error = !res || res.error

  let data = res.data?.appointment_widget_request_schedule_slots

  // TODO handle this on the app, the app should go in a runtime error if the
  // backend failed here
  if (error || !data) return {}

  return data.reduce((accumulator, currentValue) => {
    accumulator[currentValue.date] = currentValue.slotsAvailability.map(
      formatTime.fromCore
    )
    return accumulator
  }, {})
}

let QUERY = `
query appointment_widget_request_schedule_slots(
  $from: date!
  $until: date!
  $location_id: numeric!
  $medical_plan: MedicalPlan!
) {
  appointment_widget_request_schedule_slots(
    from: $from
    until: $until
    location_id: $location_id
    medical_plan: $medical_plan 
  ) {
    date
    slotsAvailability
  }
}
`
